interface Festival {
    name: string;
    date: Date;
    icon: string;
    message: string;
    description: string;
    colors: {
        from: string;
        via?: string;
        to: string;
    };
}

let mockFestival: string | null = null;

export const setMockFestival = (festival: string | null) => {
    mockFestival = festival;
};

const festivals2025: Festival[] = [
    {
        name: 'Holi',
        date: new Date(2025, 2, 14), // March 14, 2025
        icon: '🎨',
        message: 'Let\'s add colors to life!',
        description: 'Celebrate the festival of colors with joy and enthusiasm.',
        colors: {
            from: '#FF0000',
            via: '#4CAF50',
            to: '#9C27B0'
        }
    },
    {
        name: 'Ugadi',
        date: new Date(2025, 2, 31), // March 31, 2025
        icon: '🌺',
        message: 'Happy Ugadi!',
        description: 'Welcome the Telugu New Year with joy and prosperity.',
        colors: {
            from: '#FF9933',
            via: '#4CAF50',
            to: '#FFC300'
        }
    },
    {
        name: 'Ramzan',
        date: new Date(2025, 2, 1), // March 1, 2025
        icon: '🌙',
        message: 'Ramadan Kareem!',
        description: 'A blessed month of spiritual reflection and devotion.',
        colors: {
            from: '#4CAF50',
            via: '#2196F3',
            to: '#1A237E'
        }
    },
    {
        name: 'Ganesh Chaturthi',
        date: new Date(2025, 8, 2), // September 2, 2025
        icon: '🙏',
        message: 'Welcome Lord Ganesha into your home!',
        description: 'Celebrate the birth of the remover of obstacles.',
        colors: {
            from: '#FF9933',
            via: '#FF5733',
            to: '#FFC300'
        }
    },
    {
        name: 'Dussehra',
        date: new Date(2025, 9, 2), // October 2, 2025
        icon: '🏹',
        message: 'Celebrate the victory of good over evil!',
        description: 'Mark the triumph of Lord Rama over Ravana.',
        colors: {
            from: '#FF4D4D',
            via: '#FFD700',
            to: '#FF8C00'
        }
    },
    {
        name: 'Diwali',

        date: new Date(2025, 9, 20), // OCtober 20 21, 2025

        icon: '🪔',
        message: 'May the festival of lights brighten your life!',
        description: 'Celebrate the victory of light over darkness with your loved ones.',
        colors: {
            from: '#FF9933',
            via: '#FF0066',
            to: '#9933FF'
        }
    },
    {
        name: 'Christmas',
        date: new Date(2025, 11, 25), // December 25, 2025
        icon: '🎄',
        message: 'Merry Christmas!',
        description: 'Spread joy and cheer this festive season.',
        colors: {
            from: '#D32F2F',
            via: '#388E3C',
            to: '#FFFFFF'
        }
    }
];

const festivals2026: Festival[] = [
    {
        name: 'Holi',
        date: new Date(2026, 2, 3), // March 3, 2026
        icon: '🎨',
        message: 'Let\'s add colors to life!',
        description: 'Celebrate the festival of colors with joy and enthusiasm.',
        colors: {
            from: '#FF0000',
            via: '#4CAF50',
            to: '#9C27B0'
        }
    },
    {
        name: 'Ugadi',
        date: new Date(2026, 2, 20), // March 20, 2026
        icon: '🌺',
        message: 'Happy Ugadi!',
        description: 'Welcome the Telugu New Year with joy and prosperity.',
        colors: {
            from: '#FF9933',
            via: '#4CAF50',
            to: '#FFC300'
        }
    },
    {
        name: 'Ramzan',
        date: new Date(2026, 1, 18), // February 18, 2026
        icon: '🌙',
        message: 'Ramadan Kareem!',
        description: 'A blessed month of spiritual reflection and devotion.',
        colors: {
            from: '#4CAF50',
            via: '#2196F3',
            to: '#1A237E'
        }
    },
    {
        name: 'Ganesh Chaturthi',
        date: new Date(2026, 7, 22), // August 22, 2026
        icon: '🙏',
        message: 'Welcome Lord Ganesha into your home!',
        description: 'Celebrate the birth of the remover of obstacles.',
        colors: {
            from: '#FF9933',
            via: '#FF5733',
            to: '#FFC300'
        }
    },
    {
        name: 'Dussehra',
        date: new Date(2026, 8, 22), // September 22, 2026
        icon: '🏹',
        message: 'Celebrate the victory of good over evil!',
        description: 'Mark the triumph of Lord Rama over Ravana.',
        colors: {
            from: '#FF4D4D',
            via: '#FFD700',
            to: '#FF8C00'
        }
    },
    {
        name: 'Diwali',
        date: new Date(2026, 9, 10), // October 10, 2026
        icon: '🪔',
        message: 'May the festival of lights brighten your life!',
        description: 'Celebrate the victory of light over darkness with your loved ones.',
        colors: {
            from: '#FF9933',
            via: '#FF0066',
            to: '#9933FF'
        }
    },
    {
        name: 'Christmas',
        date: new Date(2026, 11, 25), // December 25, 2026
        icon: '🎄',
        message: 'Merry Christmas!',
        description: 'Spread joy and cheer this festive season.',
        colors: {
            from: '#D32F2F',
            via: '#388E3C',
            to: '#FFFFFF'
        }
    }
];

export const getCurrentFestival = (): Festival | null => {
    if (mockFestival) {
        const allFestivals = [...festivals2025, ...festivals2026];
        return allFestivals.find(f => f.name === mockFestival) || null;
    }

    const now = new Date();
    const currentYear = now.getFullYear();
    
    // Choose the appropriate festival list based on the year
    const festivals = currentYear === 2025 ? festivals2025 : festivals2026;
    
    // Check each festival
    for (const festival of festivals) {
        const festivalDate = new Date(festival.date);
        
        // Calculate date differences
        const diffTime = festivalDate.getTime() - now.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        // Show festival if within 10 days before
        if (diffDays >= 0 && diffDays <= 10) {
            return festival;
        }
    }

    return null;
}; 